import { defineStore } from 'pinia'
export const applicationStore = defineStore('application', {
  state: () => ({
    loading: false,
    menu_open:false,
    locale:'',
  }),
  getters:{
    getloading:state=>state.loading
  },
  actions: {
    setLocale(locale) {
      this.locale = locale
    },
    toggleLoading() {
      this.loading =this.loading ? false : true
    },
    findTranslations(data: any): any {
      const applyTranslations = (item: any) => {
        if (item && typeof item === 'object') {
          if (item.translations && Array.isArray(item.translations) && item.translations.length > 0) {
            const translations = item.translations[0];
            Object.keys(item).forEach(key => {
              if (key !== "translations" && key !== "id" && translations[key]) {
                item[key] = translations[key];
              }
            });
            delete item.translations;
          }
          Object.keys(item).forEach(key => {
            const value = item[key];
            if (Array.isArray(value)) {
              value.forEach(subItem => applyTranslations(subItem));
            } else if (typeof value === 'object' && value !== null) {
              applyTranslations(value);
            }
          });
        }
      };
      if (Array.isArray(data)) {
        data.forEach(applyTranslations);
      } else {
        applyTranslations(data);
      }
      return data;
    }
  },
  
})